import {connect} from 'react-redux'
import {sendVerifyEmail} from 'actions/verifyEmail'
import styles from './VerifyEmail.css'

class VerifyEmail extends React.Component {
  componentDidMount () {
    let accessToken = this.props.params.token
    this.props.dispatch(sendVerifyEmail(accessToken))
  }

  render () {
    let {invalidTokenVerifyEmail} = this.props.data.verifyEmail
    return (
      <div className='container'>
        <div className='row'>
          {invalidTokenVerifyEmail &&
            <div className={styles['invalid-message']}>
              Your access token is invalid or expired
            </div>}
        </div>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    data: {
      verifyEmail: state.verifyEmail
    }
  }
}

export default connect(mapStateToProps)(VerifyEmail)



// WEBPACK FOOTER //
// ./app/pages/VerifyEmail/VerifyEmail.js